import type { IParticleEmitter, ParticleEmitterConfig } from '../IRenderer';

/**
 * createParticleEmitter — substrate-agnostic factory for particle emitters.
 *
 * Phase H10 Arc λ.10 (2026-05-10): PhaserParticleEmitter fallback removed.
 * PixiFactoriesRegistry wires the Pixi impl at boot.
 *
 * Pixi mini-emitter draws solid-color circles via IGraphics primitives — no
 * texture needed; the `_textureKey` parameter is retained for call-site
 * compatibility (legacy Phaser sprite-based emitters needed it).
 */

type PixiFactory = (cfg: ParticleEmitterConfig) => IParticleEmitter;

let pixiFactory: PixiFactory | null = null;

export function registerPixiParticleEmitterFactory(fn: PixiFactory): void {
  pixiFactory = fn;
}

export function createParticleEmitter(
  _scene: unknown,
  _textureKey: string,
  cfg: ParticleEmitterConfig,
): IParticleEmitter {
  if (!pixiFactory) {
    throw new Error('[createParticleEmitter] Pixi factory not registered. Call registerAllPixiFactories() at boot.');
  }
  return pixiFactory(cfg);
}
